export const articles = [
  {
    id: 1,
    title: "Why Naruto: Saihen?",
    slug: "whynarutosaihen",
    subtitle: null,
    sections: [
      {
        heading: "The Goal",
        content: [
          "Let's face it; the story of Naruto is lacking in many aspects.",
          "Saihen seeks to correct plot inconsistencies, deepen shallow characters, and tighten worldbuilding. This is not to say the original series is entirely meritless. <b>Kishimoto did superbly under the constraints of serialization.</b> There is a reason the work resonates with so many.",
          "If I didn't love Naruto, I wouldn't have bothered with Saihen."
        ]
      },
      {
        heading: "Key Changes",
        content: [
        ],
        listType: "ol",
        list: [
          {
            title: "Less shōnen.",
            description: [
              "The power-level is pulled back hard. No meteors. No izanagi. No Kurama vs Susano'o gundam fights. No infinite tsukiyomis. Fights are not about who can ass-pull the hardest.",
              "When power <i>does</i> then break limits, it's going to hit hard as fuck. There is one absolute apex; Kurama-juiced-Naruto vs Pain."
            ]
          },
          { 
            title: "More seinen.",
            description: [
              "Saihen leans harder into Japanese mythology and traditional politics. This not a tonal pivot as much as simple furtherance; the original series was heavily inspired by mythology and gestures in the direction of political drama with its worldbuilding, the Five Kage Summit, then again when the war arc begins."
            ]
          },
          {
            title: "Hand seals are absolute.",
            description: [
              "All jutsu require seals. No exceptions. A comprehensive system will prevent drift."
            ]
          },
          {
            title: "Clearer villains.",
            description: [
              "Orochimaru → Pain → Madara. That's it. Kaguya and the Ōtsutsuki are relegated to in-universe myth and history; they'll serve purely as texture.",
              "Pain seeks to eliminate bijū by killing jinchūriki. Madara seeks conquest. No metaphysical gymnastics are to be performed by any party."
            ]
          },
          {
            title: "Less Sasuke moping.",
            description: [
              "In Part II, Naruto and Sakura will be less Sasuke obsessed."
            ]
          },
          {
            title: "More focus on Konoha Twelve.",
            description: [
              "Especially in Part II. Our roster of deuteragonists will be more<span class='ellipsis'>…</span><i>there</i>."
            ]
          },
          {
            title: "Jinchūriki/Bijū rebuilt.",
            description: [
              "Gaara/Shukaku, Killer B / Gyūki, and Naruto/Kurama stay mostly intact. All others are rebuilt from the ground up with stronger yōkai influence. Some names survive. Concepts don't. "
            ]
          },
          {
            title: "One Edo Tensei.",
            description: [
              "Madara is the <i>only character to ever be resurrected</i>. Aside from him, the dead stay dead."
            ]
          },
          {
            title: "No wars.",
            description: [
              "Shinobi don't war."
            ]
          },
          {
            title: "Better romances.",
            description: [
              "Romances are integral to the original series, but it doesn't elaborate upon them sufficiently. Saihen will."
            ]
          }
        ]
      },
      {
        content: [
          "There are a ton more small changes (the Gates, team name convention, villages, characters, arcs, mechanisms) which I might formalize a write-up on later. For now, I just recommend reading the available chapters. <a href='/whatwontdie'>What Won't Die</a> is probably the strongest; if that can't hook you, then Naruto: Saihen isn't for you."
        ]
      }
    ]
  }
];
